import { render, staticRenderFns } from "./_message_tag_manager.vue?vue&type=template&id=40095a39&scoped=true&"
import script from "./_message_tag_manager.vue?vue&type=script&lang=js&"
export * from "./_message_tag_manager.vue?vue&type=script&lang=js&"
import style0 from "./_message_tag_manager.vue?vue&type=style&index=0&id=40095a39&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40095a39",
  null
  
)

export default component.exports